import React, {
    useEffect, useState,
} from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import { useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import ReactPlayer from 'react-player';
import SliderStyle from '../../assets/jss/components/SliderStyle';
import CustomTypography from '../../components/Typography/CustomTypography';
import Button from '../../components/Button/CustomButton';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import ImgDialog from '../../components/Dialog/ImgDialog';
import FormDialog from '../../components/Dialog/FormDialog';
import { MEDIA_TYPE } from '../../common/Constants';
import Snackbar from '../../components/Snackbar/Snackbar';

import BusinessContactForm from './BusinessContactForm';
import { NavigateBeforeIcon, NavigateNextIcon } from '../../components/Icons/Icon';
import BusinessCardExchange from './BusinessCardExchange';

const useStyles = makeStyles(SliderStyle);

const SliderCustomer = (props) => {
    const {
        data, companyList, nameEvent, companyId,
        companyInfo,
        totalProducts,
        fetchData,
        eventDisplayBusinessCard,
        sendBusinessCard,
        successSendBusinessCard,
        clearExchangeBusinessCard,
        product,
        getProduct,
        isAuthorized,
        token,
        queryStr,
        isProductsViewable,
        eventInfo,
        customText,
        customColorExhibitor,
        customTextPersonInfo,
        customTextCompany,
        isPreview,
    } = props;
    const classes = useStyles();
    const [value, setValue] = useState(0);
    const [param, setParam] = useState([]);
    const [item, setItem] = useState({});
    const [openDialogImg, setOpenDialogImg] = useState(false);
    const [linkPrev, setLinkPrev] = useState({ link: '', disable: true });
    const [linkNext, setLinkNext] = useState({ link: '', disable: true });
    const [openBusinessContactForm, setOpenBusinessContactForm] = useState(false);
    const [isOpenSnackBar, setOpenSnackBar] = useState(false);
    const [isOpenDialogCompanyInfo, setIsOpenDialogCompanyInfo] = useState(false);
    const [companyInfoView, setCompanyInfoView] = useState([]);
    const [openBusinessCardExchangeDialog, setOpenBusinessCardExchangeDialog] = useState(false);
    const history = useHistory();
    const [isOpenSnackBarPreviewPage, setIsOpenSnackBarPreviewPage] = useState(false);

    const intl = useIntl();

    useEffect(() => {
        setParam(data);
    }, [data]);

    useEffect(() => {
        setItem(param[value]);

        if (param[value]) {
            getProduct(companyId, param[value].id);
        }
    }, [param, value, companyId, getProduct]);

    useEffect(() => {
        if (companyList.length > 0) {
            const idCompanyPrev = companyList[companyList.indexOf(Number(companyId)) - 1];
            const idCompanyNext = companyList[companyList.indexOf(Number(companyId)) + 1];

            if (idCompanyPrev) {
                setLinkPrev({ ...linkPrev, link: `/${nameEvent}/${idCompanyPrev}/products${queryStr}`, disable: false });
            } else {
                setLinkPrev({ ...linkPrev, link: '', disable: true });
            }
            if (idCompanyNext) {
                setLinkNext({ ...linkNext, link: `/${nameEvent}/${idCompanyNext}/products${queryStr}`, disable: false });
            } else {
                setLinkNext({ ...linkNext, link: '', disable: true });
            }
        }
    }, [companyList, companyId]);

    useEffect(() => {
        if (!_.isEmpty(companyInfo)) {
            setCompanyInfoView([
                { value: companyInfo.full_name, label: customTextCompany?.field_name?.exhibitor_name || intl.formatMessage({ id: 'register.exhibitionName' }) },
                { value: companyInfo.company_type, label: customTextCompany?.field_name?.industry_type || intl.formatMessage({ id: 'industryType' }) },
                { value: companyInfo.zip_code, label: customTextCompany?.field_name?.zip_code || intl.formatMessage({ id: 'zipCode' }) },
                { value: companyInfo.address, label: customTextCompany?.field_name?.address || intl.formatMessage({ id: 'address' }) },
                { value: companyInfo.phone_number, label: customTextCompany?.field_name?.phone_number || intl.formatMessage({ id: 'phoneNumber' }) },
                { value: companyInfo.fax_number, label: customTextCompany?.field_name?.fax_number || intl.formatMessage({ id: 'exhibition.fax' }) },
                { value: companyInfo.url, label: customTextCompany?.field_name?.url || 'ＵＲＬ' },
                { value: companyInfo.description, label: customTextCompany?.field_name?.info_guide || intl.formatMessage({ id: 'register.guideInfo' }) },
            ]);
            setValue(0);
        }
    }, [companyInfo, customTextCompany]);

    useEffect(() => {
        if (successSendBusinessCard) {
            setOpenBusinessCardExchangeDialog(false);
            setOpenSnackBar(true);
            clearExchangeBusinessCard();
        }
    }, [successSendBusinessCard, clearExchangeBusinessCard]);

    const toggleBusinessContactForm = () => {
        setOpenBusinessContactForm(!openBusinessContactForm);
    };

    const handleGetCommonCompanyInfo = () => {
        setIsOpenDialogCompanyInfo(true);
    };

    const nextProduct = () => {
        const nextValue = value + 1;
        const currentNumberOfProducts = param.length;

        if (nextValue < currentNumberOfProducts) {
            setValue(nextValue);

            if (nextValue === currentNumberOfProducts - 1 && currentNumberOfProducts < totalProducts) {
                fetchData();
            }
        }
    };

    const prevProduct = () => {
        if (value > 0) setValue(value - 1);
    };

    const handleNextPrev = (href) => {
        history.push(href);
    };
    const handleCloseTab = () => {
        window.close();
    };   

    const renderButton = (title, href, target) => (
        <Button
            color="navy"
            gradient
            size="sm"
            round
            className={classes.btnStyle}
            href={!isPreview && href}
            target={!isPreview && target}
            onClick={isPreview ? () => setIsOpenSnackBarPreviewPage(true) : () => {}}
            buttonTextColor={customColorExhibitor?.button_text_color}
            buttonBackgroundColor={customColorExhibitor?.button_background_color?.common_button}
        >
            {title}
        </Button>
    );
    const renderButtonNextPrev = (title, href, disable, newTitle, backgroundColor) => (
        <Button
            color="navy"
            gradient
            size="sm"
            round
            className={classes.buttonBig}
            onClick={() => handleNextPrev(href)}
            // href={href}
            disabled={disable}
            buttonTextColor={customColorExhibitor?.button_text_color}
            buttonBackgroundColor={backgroundColor}
        >
            {newTitle || title}
        </Button>
    );

    const showBusinessCardDialog = (e) => {
        e.stopPropagation();
        setOpenBusinessCardExchangeDialog(true);
    };
    return (
        <GridContainer>
            <GridItem md={9} xs={12}>
                {
                    param.length > 0 && item && !_.isNull(eventDisplayBusinessCard) ? (
                        <>
                            <GridContainer style={{ marginTop: '20px',marginBottom:'30px' }}>
                                <GridItem style={{ margin: 'auto' }}>
                                    <CustomTypography
                                        variant="h4"
                                        bold
                                        align="center"
                                        color="danger"
                                        customColor={customColorExhibitor?.contents_text_color}
                                    >
                                        { "<" + item.name + ">" }
                                    </CustomTypography>
                                </GridItem>
                            </GridContainer>

                            <div className={classes.productSlider}>
                                <button
                                    type="button"
                                    onClick={prevProduct}
                                    disabled={value === 0}
                                    className={`${classes.productSliderArrow} ${classes.productSliderPrevArrow}`}
                                >
                                    <NavigateBeforeIcon color={customColorExhibitor?.button_background_color?.common_button || '#001d83'} size="60px" />
                                </button>
                                <button
                                    type="button"
                                    onClick={nextProduct}
                                    disabled={value === totalProducts - 1}
                                    className={`${classes.productSliderArrow} ${classes.productSliderNextArrow}`}
                                >
                                    <NavigateNextIcon color={customColorExhibitor?.button_background_color?.common_button || '#001d83'} size="60px" />
                                </button>

                                <div className={classes.sliderFirst}>
                                    {item.media_type === MEDIA_TYPE.IMAGE && (
                                        <img
                                            src={item.media}
                                            alt=""
                                            className={classes.imgstyle}
                                            onClick={() => setOpenDialogImg(true)}
                                        />
                                    )}
                                    {item.media_type === MEDIA_TYPE.AUDIO
                                        && (
                                            <>
                                                <ReactPlayer
                                                    controls
                                                    config={{
                                                        attributes: {
                                                            controlsList: 'nodownload',
                                                            style: {
                                                                outline: 'none',
                                                                margin: 'auto',
                                                                maxHeight: '100%',
                                                                maxWidth: 'calc(100% - 120px)',
                                                            },
                                                        },
                                                        forceAudio: true,
                                                    }}
                                                    width="100%"
                                                    url={(item.media && token) && `${item.media}?token=${token}`}
                                                    style={{ display: 'flex', margin: 'auto' }}
                                                />
                                            </>
                                        )}
                                    {item.media_type === MEDIA_TYPE.VIDEO
                                        && (
                                            <ReactPlayer
                                                controls
                                                config={{
                                                    attributes: {
                                                        controlsList: 'nodownload',
                                                        style: {
                                                            outline: 'none',
                                                            margin: 'auto',
                                                            maxHeight: '100%',
                                                            maxWidth: '100%',
                                                        },
                                                    },
                                                }}
                                                width="100%"
                                                url={(item.media && token) && `${item.media}?token=${token}`}
                                                style={{ display: 'flex', margin: 'auto' }}
                                            />
                                        )}
                                </div>
                            </div>
                            <GridContainer style={{ marginTop: '20px' }}>

                                <GridItem style={{ margin: 'auto' }}>
                                    {  /* 
                                    <CustomTypography
                                        variant="h5"
                                        bold
                                        align="center"
                                        customColor={customColorExhibitor?.contents_text_color}
                                    >
                                        {item.name}
                                    </CustomTypography>
                                    2024-2-21 item.nameを上部に配置のため、ここで表示させない。
                                    */
                                    }

                                    <CustomTypography
                                        className={classes.desc}
                                        align="left"
                                        customColor={customColorExhibitor?.contents_text_color}
                                    >
                                        {item.description}
                                    </CustomTypography>
                                </GridItem>
                                <Box display="flex" alignItems="center" justifyContent="center" flexWrap="wrap" width="100%">
                                    {item.business_contact && (
                                        <Button
                                            color="navy"
                                            gradient
                                            size="sm"
                                            round
                                            className={classes.btnStyle}
                                            onClick={!isPreview ? toggleBusinessContactForm : () => setIsOpenSnackBarPreviewPage(true)}
                                            buttonTextColor={customColorExhibitor?.button_text_color}
                                            buttonBackgroundColor={customColorExhibitor?.button_background_color?.common_button}
                                        >
                                            {customText?.button_name?.business_contact || intl.formatMessage({ id: 'productRegister.businessContactNewText' })}
                                        </Button>
                                    )}

                                    {item.document_link
                                        && renderButton(customText?.button_name?.document_request || intl.formatMessage({ id: 'productRegister.documentRequestReception' }),
                                            item.check_mail_document_link ? `https://mail.google.com/mail/?view=cm&fs=1&to=${item.document_link}` : item.document_link, '_blank')}

                                    {item.document && renderButton(customText?.button_name?.download_materials || intl.formatMessage({ id: 'exhibition.documentDownload' }), item.document, '_blank')}

                                    {(item.has_outside_link && isAuthorized)
                                        && renderButton(
                                            customText?.button_name?.direct_consultation || intl.formatMessage({ id: 'productRegister.externalLink' }),
                                            product.outside_link_url, '_blank',
                                        )}

                                    {item.survey_link && renderButton(
                                        customText?.button_name?.questionnaire || intl.formatMessage({ id: 'productRegister.survey' }),
                                        item.survey_link, '_blank',
                                    )}

                                    {item.purchase_link && renderButton(
                                        customText?.button_name?.purchase_products || intl.formatMessage({ id: 'productRegister.purchaseLink' }),
                                        item.purchase_link, '_blank',
                                    )}

                                    {item.outside2_link && renderButton(
                                        customText?.button_name?.board_salon || intl.formatMessage({ id: 'exhibition.boardSalon' }),
                                        item.outside2_link, '_blank',
                                    )}

                                    {item.outside3_link && renderButton(
                                        customText?.button_name?.external_link || intl.formatMessage({ id: 'productRegister.externalLink3' }),
                                        item.outside3_link, '_blank',
                                    )}

                                    {(item.business_card && eventDisplayBusinessCard) && (
                                        <Button
                                            color="navy"
                                            gradient
                                            size="sm"
                                            round
                                            className={classes.btnStyle}
                                            onClick={!isPreview ? showBusinessCardDialog : () => setIsOpenSnackBarPreviewPage(true)}
                                            buttonTextColor={customColorExhibitor?.button_text_color}
                                            buttonBackgroundColor={customColorExhibitor?.button_background_color?.common_button}
                                        >
                                            {customText?.button_name?.business_card || intl.formatMessage({ id: 'exchangeBusinessCard' })}
                                        </Button>
                                    )}
                                </Box>

                                {companyList.length > 0 && !isPreview &&  ( ! eventInfo.hasOwnProperty('category') || eventInfo?.category.length < 1) && (
                                    <Box display="flex" alignItems="center" justifyContent="center" flexWrap="wrap" width="100%">
                                        {renderButtonNextPrev(
                                            intl.formatMessage({ id: 'exhibition.previousCompany' }),
                                            linkPrev.link,
                                            linkPrev.disable,
                                            customText?.button_name?.previous_company,
                                            customColorExhibitor?.button_background_color?.common_button,
                                        )}
                                        {renderButtonNextPrev(
                                            intl.formatMessage({ id: 'exhibition.nextCompany' }),
                                            linkNext.link,
                                            linkNext.disable,
                                            customText?.button_name?.next_company,
                                            customColorExhibitor?.button_background_color?.common_button,
                                        )}
                                    </Box>
                                )}
                                { ( eventInfo.hasOwnProperty('category') && eventInfo.category.length >=1 ) && (
                                      <Box  display="flex" alignItems="center" justifyContent="center" flexWrap="wrap" width="100%">
                                        <Button 
                                            color="navy"
                                            gradient
                                            size="sm"
                                            round
                                            className={classes.buttonBig}
                                            onClick={handleCloseTab}
                                            buttonTextColor={customColorExhibitor?.button_text_color}
                                            buttonBackgroundColor={customColorExhibitor?.button_background_color?.common_button}>閉じる
                                        </Button>
                                      </Box>
                                )}
                            </GridContainer>
                        </>
                    ) : (
                        <>
                            {(!param.length && isProductsViewable) && (
                                <CustomTypography
                                    align="center"
                                    variant="subtitle1"
                                    style={{ marginBottom: '15px' }}
                                    customColor={customColorExhibitor?.contents_text_color}
                                >
                                    { intl.formatMessage({ id: 'exhibition.noProductRegister' })}
                                </CustomTypography>
                            )}
                            {!isProductsViewable && (
                                <CustomTypography
                                    align="center"
                                    variant="subtitle1"
                                    style={{ marginBottom: '15px' }}
                                    customColor={customColorExhibitor?.contents_text_color}
                                >
                                    { intl.formatMessage({ id: 'organizerPosterList.pastEventPeriod' })}
                                </CustomTypography>
                            )}

                            {companyList.length > 0 && !isPreview && ( ! eventInfo.hasOwnProperty('category') || eventInfo?.category.length < 1) &&  (
                                <Box display="flex" alignItems="center" justifyContent="center" flexWrap="wrap" width="100%">
                                    {renderButtonNextPrev(
                                        intl.formatMessage({ id: 'exhibition.previousCompany' }),
                                        linkPrev.link,
                                        linkPrev.disable,
                                        customText?.button_name?.previous_company,
                                        customColorExhibitor?.button_background_color?.common_button,
                                    )}
                                    {renderButtonNextPrev(
                                        intl.formatMessage({ id: 'exhibition.nextCompany' }),
                                        linkNext.link,
                                        linkNext.disable,
                                        customText?.button_name?.next_company,
                                        customColorExhibitor?.button_background_color?.common_button,
                                    )}
                                </Box>
                            )}
                        </>
                    )
                }
            </GridItem>
            <GridItem md={3} xs={12}>
                <Button
                    color="navy"
                    className={classes.btnShowCompanyInfo}
                    onClick={!isPreview ? handleGetCommonCompanyInfo : () => setIsOpenSnackBarPreviewPage(true)}
                    buttonTextColor={customColorExhibitor?.button_text_color}
                    buttonBackgroundColor={customColorExhibitor?.button_background_color?.common_button}
                >
                    {customText?.button_name?.exhibitors_detailed_info
                        ? (
                            <>
                                {customText?.button_name?.exhibitors_detailed_info.length > 4 ? (
                                    <>
                                        {customText?.button_name?.exhibitors_detailed_info.slice(0, (customText?.button_name?.exhibitors_detailed_info.length) / 2)}
                                        <br />
                                        {customText?.button_name?.exhibitors_detailed_info.slice((customText?.button_name?.exhibitors_detailed_info.length) / 2)}
                                    </>
                                ) : (
                                    customText?.button_name?.exhibitors_detailed_info
                                )}
                            </>
                        )
                        : (
                            <>
                                {intl.formatMessage({ id: 'exhibition.detailInfoButton' })}
                                <br />
                                {intl.formatMessage({ id: 'exhibition.detailInfoExhibit' })}
                            </>
                        )}
                </Button>
                {param.length > 0 && param.map((items, i) => (
                    <div className={classes.divDot} key={`${items.company}_${items.id}`}>
                        <div
                            className={value === i ? classes.styleDotActive : classes.styleDot}
                            style={{
                                backgroundImage: items.media_type === 0
                                    ? `url(${items.media})`
                                    : 'url("/resources/imgDefaultVideo.jpg")',
                            }}
                            onClick={() => {
                                window.scrollTo({
                                    top: 200,
                                    left: 0,
                                    behavior: 'smooth',
                                });
                                setValue(i);
                            }}
                            role="button"
                            tabIndex={i}
                            aria-label={intl.formatMessage({ id: 'exhibition.merchandise' })}
                        />

                        <CustomTypography
                            bold
                            align="left"
                            className={classes.titleName}
                            onClick={() => {
                                window.scrollTo({
                                    top: 200,
                                    left: 0,
                                    behavior: 'smooth',
                                });
                                setValue(i);
                            }}
                            customColor={customColorExhibitor?.contents_text_color}
                        >
                            {items.name}
                        </CustomTypography>
                    </div>
                ))}

            </GridItem>
            <ImgDialog
                open={openDialogImg}
                href={item && item.media}
                handleClose={() => setOpenDialogImg(false)}
            />
            <BusinessContactForm
                isOpen={openBusinessContactForm}
                onClose={toggleBusinessContactForm}
                showSnackBar={() => setOpenSnackBar(true)}
                customText={customText}
                customColorExhibitor={customColorExhibitor}
            />

            <Snackbar
                open={isOpenSnackBar}
                onClose={() => setOpenSnackBar(false)}
                message={intl.formatMessage({ id: 'exhibition.sendCompleted' })}
                severity="success"
                autoHideDuration={2000}
            />
            <Snackbar
                open={isOpenSnackBarPreviewPage}
                onClose={() => setIsOpenSnackBarPreviewPage(false)}
                message={intl.formatMessage({ id: 'common.noPreview' })}
                severity="error"
                autoHideDuration={1000}
            />
            <FormDialog
                maxWidth="sm"
                isOpen={isOpenDialogCompanyInfo}
                handleClose={() => setIsOpenDialogCompanyInfo(false)}
                title={customText?.button_name?.exhibitors_detailed_info || intl.formatMessage({ id: 'exhibition.exhibitorDetailInfo' })}
                paperProps={{
                    style: {
                        maxHeight: '60vh',
                    },
                }}
                customColor={customColorExhibitor?.contents_text_color}
            >
                {
                    companyInfoView.map((info) => (
                        <GridContainer key={info.value?.full_name}>
                            <GridItem xs={5} sm={3} md={3}>
                                <CustomTypography bold variant="subtitle1" customColor={customColorExhibitor?.contents_text_color}>
                                    {info.label}
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={7} sm={9} md={9}>
                                <CustomTypography variant="subtitle1" customColor={customColorExhibitor?.contents_text_color}>
                                    {info.value}
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>
                    ))
                }
            </FormDialog>

            <FormDialog
                maxWidth="md"
                isOpen={openBusinessCardExchangeDialog}
                handleClose={() => setOpenBusinessCardExchangeDialog(false)}
                title={customText?.button_name?.business_card || intl.formatMessage({ id: 'exchangeBusinessCard' })}
                isNaughtyChildren
                customColor={customColorExhibitor?.contents_text_color}
            >
                <BusinessCardExchange
                    handleClose={() => setOpenBusinessCardExchangeDialog(false)}
                    productId={param.length ? param[value].id : null}
                    sendBusinessCard={sendBusinessCard}
                    isAuthorized={isAuthorized}
                    customTextPersonInfo={customTextPersonInfo}
                    customColorExhibitor={customColorExhibitor}
                />
            </FormDialog>
        </GridContainer>
    );
};

SliderCustomer.defaultProps = {
    data: {},
    companyList: [],
    nameEvent: '',
    companyId: '',
    product: {},
    companyInfo: {},
    token: '',
    queryStr: '',
    isProductsViewable: false,
    eventInfo: {},
    customText: {},
    customColorExhibitor: {},
    customTextPersonInfo: {},
    customTextCompany: {},
    isPreview: false,
};

SliderCustomer.propTypes = {
    data: PropTypes.oneOfType([() => null, PropTypes.object]),
    companyList: PropTypes.oneOfType([() => null, PropTypes.array]),
    nameEvent: PropTypes.string,
    companyId: PropTypes.string,
    getProduct: PropTypes.func.isRequired,
    product: PropTypes.oneOfType([() => null, PropTypes.object]),
    companyInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    totalProducts: PropTypes.number.isRequired,
    fetchData: PropTypes.func.isRequired,
    eventDisplayBusinessCard: PropTypes.bool.isRequired,
    sendBusinessCard: PropTypes.func.isRequired,
    successSendBusinessCard: PropTypes.bool.isRequired,
    clearExchangeBusinessCard: PropTypes.func.isRequired,
    isAuthorized: PropTypes.bool.isRequired,
    token: PropTypes.string,
    queryStr: PropTypes.string,
    isProductsViewable: PropTypes.bool,
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    customText: PropTypes.oneOfType([() => null, PropTypes.object]),
    customColorExhibitor: PropTypes.oneOfType([() => null, PropTypes.object]),
    customTextPersonInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    customTextCompany: PropTypes.oneOfType([() => null, PropTypes.object]),
    isPreview: PropTypes.bool,
};

export default SliderCustomer;
